module.exports = __webpack_public_path__ + "img/down_title.09bd4cfd.png";